import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary mb-6" }, "Datos de la cuenta", -1)
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Nombre de usuario (correo electrónico)", -1)
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Contraseña", -1)
const _hoisted_7 = { class: "col-sm-12 mt-5" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "col-sm-12" }


export default /*#__PURE__*/_defineComponent({
  __name: 'StepAccount',
  props: {
    form: null
  },
  setup(__props: any) {

const props = __props as {
    form: any;
};



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form_item, {
        prop: "username",
        class: "mb-8",
        rules: [{required: true, message:'Campo obligatorio', trigger:['blur', 'change']}]
      }, {
        label: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.username) = $event)),
            modelModifiers: { trim: true },
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form_item, {
        prop: "password",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.password) = $event)),
            modelModifiers: { trim: true },
            type: "password",
            "show-password": "",
            maxlength: "30"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_form_item, {
        prop: "terms",
        rules: [{required: true, message:'Campo obligatorio', trigger:['blur', 'change']}],
        class: "m-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: __props.form.terms,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.terms) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Acepto los términos y condiciones.")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_form_item, {
        prop: "dataProcessing",
        rules: [{required: true, message:'Campo obligatorio', trigger:['blur', 'change']}],
        class: "m-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: __props.form.dataProcessing,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.dataProcessing) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Acepto la cláusula de procesamiento de datos")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_form_item, {
        prop: "disclaimer",
        rules: [{required: true, message:'Campo obligatorio', trigger:['blur', 'change']}],
        class: "m-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: __props.form.disclaimer,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.disclaimer) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Acepto el aviso legal")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})